"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const react_1 = __importDefault(require("react"));
exports.default = _ref => {
  let width = _ref.width,
    height = _ref.height;
  return react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 32 40"
  }, react_1.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, react_1.default.createElement("path", {
    fill: "#E6EAEB",
    d: "M3 2h26l-4.5 36h-17L3 2z"
  }), react_1.default.createElement("path", {
    fill: "#C9CFD2",
    d: "M3 2h26l-.6 2.5H3.6L3 2z"
  }), react_1.default.createElement("path", {
    fill: "#57A7DE",
    d: "M4.8 16c3-2.2 6 1.4 9 .2s6 1.6 9 .4c1.5-.6 3-.8 4.4-.6L24.6 36H7.4L4.8 16z"
  }), react_1.default.createElement("path", {
    fill: "#4A94CC",
    d: "M7.4 36h17.2l-.7-4H8.1l-.7 4z"
  })));
};